import angular from 'angular';
import repairs from './repairs.yml';
import { forEach } from 'lodash';

forEach(repairs, (category) =>  {
  forEach(category.repair_items, (item) => {
    item.svg = require(`raw!../../../images/repairs/${item.svg}.svg`);
  });
});

module.exports = angular.module('market.routes.repairs', [
  require('angular-ui-router'),
  require('angular-sanitize'),
])
.config(function($stateProvider, $sanitizeProvider) {
  $stateProvider.state('repairs', {
    parent: 'root',
    url: '/repairs',
    template: require('./repairs.jade')(),
    data: {
      meta: {
        titleSuffix: " | Common Repair Items",
      }
    },
    controllerAs: 'repairsCtrl',
    controller: class {
      constructor($timeout) {
        this.$timeout = $timeout;
      }

      repairs = repairs;

      toggleDetails(item) {
        // Hide details
        if (item === "" || (item === this.selected && this.showDetails)) {
          this.showDetails = false;
          this.$timeout(() => {
            this.overlayIsHidden = true;
          }, 500);

        // Show details
        } else {
          this.selected = item;
          this.overlayIsHidden = false;
          // HACK: without a timeout, the opacity snaps to 1 with no transition
          this.$timeout(() => {
            this.showDetails = true;
          });
        }
      }
    }
  });

  $sanitizeProvider.enableSvg(true);
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/repairs.js
 **/